// Dependencies
import { RadioButton } from 'primereact/radiobutton';
import React, { Component } from 'react';

// Multi lang
import { withTranslation } from 'react-multi-lang';
// Styling
import './allowance-presence-ticket-detail.scss';

class AllowancePresenceTicketDetailComponent extends Component {

  render() {

    let presenceTicketTypes = [
        { name: this.props.t("allowances.dialog.presence-tickets.type-1").replace("{0}", this.props.allowancePresenceTicket.presenceTicketTypeDirectionPrice), key: 1 },
        { name: this.props.t("allowances.dialog.presence-tickets.type-2").replace("{0}", this.props.allowancePresenceTicket.presenceTicketTypeOthersPrice), key: 2 },
    ];

    return (
                this.props.allowancePresenceTicket !== null ?
                    <>
                        <div className="col-12 mgt-10">
                            <label><b>{this.props.t("allowances.dialog.presence-tickets.type-title-1")}</b></label>
                        </div>
                        <div className="col-12">
                            <label>{this.props.t("allowances.dialog.presence-tickets.type-title-2")}</label>
                        </div>
                        <div className="col-12">
                            {presenceTicketTypes.map((presenceTicketType) => {
                                return (
                                    <div key={presenceTicketType.key} className="flex">
                                        <RadioButton disabled inputId={presenceTicketType.key} className='mgt-5' name="presenceTicketType" value={presenceTicketType} checked={this.props.allowancePresenceTicket.presenceTicketType === presenceTicketType.key} />
                                        <label htmlFor={presenceTicketType.key} className="mgt-5 ml-2">{presenceTicketType.name}</label>
                                    </div>
                                );
                            })}
                        </div>
                        <div className="col-12">
                            <label>{this.props.t("allowances.dialog.presence-tickets.type-nb")}</label>
                        </div>
                    </>
                : null
        );
    }
}

export default withTranslation(AllowancePresenceTicketDetailComponent);